/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const migrateExampleAudioIdsResultSchema = z.object({
  migrated: z.number(),
  skipped: z.number(),
  errors: z.array(z.string()),
});

export type IMigrateExampleAudioIdsResult = z.infer<typeof migrateExampleAudioIdsResultSchema>;

export const migrateExampleAudioIdsResponseSchema = createApiResponseSchema(
  migrateExampleAudioIdsResultSchema,
) as z.ZodSchema<IAPI<IMigrateExampleAudioIdsResult>>;

export type IMigrateExampleAudioIdsResponse = IAPI<IMigrateExampleAudioIdsResult>;
